import React, { Component } from "react";
import { DeviceFormContainer } from "../containers";
import { Header } from "../components/header";
export class DeviceForm extends Component {
  constructor(props) {
    super();
  }

  render() {
    return (
      <div>
        <Header />
        <div className="container">
          <DeviceFormContainer deviceSerial={this.props.match.params.deviceSerial} />
        </div>
      </div>
    );
  }
}
